import { AxiosResponse } from "axios";

import { DAO_SESHAT } from "@/api/DAO";
import { AUDIT_LOGS_URL } from "@/api/URL-constants";

import { AuditLog, AuditLogsResponse } from "@/models/api/logs.model";

const getAuditLogs = (): Promise<AuditLog[]> => {
  return DAO_SESHAT()
    .get(AUDIT_LOGS_URL)
    .then((response: AxiosResponse<AuditLogsResponse>): AuditLog[] => {
      return response.data.data;
    });
};

export { getAuditLogs };
